import { render } from "./role-menu-view.html?vue&type=template&id=0addfb2c&scoped=true&ts=true"
import script from "./role-menu-view.ts?vue&type=script&lang=ts"
export * from "./role-menu-view.ts?vue&type=script&lang=ts"

import "./role-menu-view.scss?vue&type=style&index=0&id=0addfb2c&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0addfb2c"]])

export default __exports__